import React, { useEffect, useState } from "react";
import { message, Checkbox, Button, Modal } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import Layout from "../../Layout";
import banner from "../../assets/images/banner1.jpg";
import { FaCheck } from "react-icons/fa6";
import { RxCross1 } from "react-icons/rx";
import ConsentServices from "../../Services/ConsentServices";
import { APP_ROUTES } from "../../PageRouting/pageRoutes";

function LogConsent() {
  const patJson = localStorage.getItem("patientData");
  const patObj = patJson ? JSON.parse(patJson) : null;
  const navigate = useNavigate();
  const location = useLocation();

  const [activeModal, setActiveModal] = useState(null); // Track which modal is open

  const [consentData, setConsentData] = useState({
    terms: "P",
    privacy: "P",
    doctors: "P",
    hospitals: "P",
    pharmacy: "P",
    diagnostics: "P",
  });

  useEffect(() => {
    getConsent();
  }, []);

  const getConsent = async () => {
    const payload = {
      // account_Id: patObj?.account_Id,
      // clinic_Id: patObj?.clinic_Id,
      patientId: patObj?.patientId,
    };
    try {
      const response = await ConsentServices.getconsentFilter(payload);
      const data = response.data[0];

      setConsentData({
        terms: data.termsCond,
        privacy: data.privacyPolicy,
        doctors: data.shareMedWithDocs,
        hospitals: data.shareMedWithHosp,
        pharmacy: data.shareEpresWithPharmacy,
        diagnostics: data.shareEpresWithDiagnostics,
      });
    } catch (e) {
      console.error("Error fetching consent:", e);
    }
  };

  const handleChange = (type, value) => {
    setConsentData((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  // "createdBy": "string",
  // "createdDate": "2025-03-28 05:23:55",
  // "modifiedBy": "string",
  // "modifiedDate": "2025-03-28 05:23:55",

  const now = new Date();
  const formattedTime =
    now.getFullYear() +
    "-" +
    String(now.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(now.getDate()).padStart(2, "0") +
    " " +
    String(now.getHours()).padStart(2, "0") +
    ":" +
    String(now.getMinutes()).padStart(2, "0") +
    ":" +
    String(now.getSeconds()).padStart(2, "0");

  const handleSubmit = async () => {
    try {
      const postData = {
        account_Id: patObj?.account_Id,
        clinic_Id: patObj?.clinic_Id,
        patientId: patObj?.patientId,
        createdBy: patObj?.patientId,
        modifiedBy: patObj?.patientId,
        createdDate: formattedTime,
        modifiedDate: formattedTime,
        privacyPolicy: consentData.privacy,
        shareEpresWithDiagnostics: consentData.diagnostics,
        shareEpresWithPharmacy: consentData.pharmacy,
        shareMedWithDocs: consentData.doctors,
        shareMedWithHosp: consentData.hospitals,
        termsCond: consentData.terms,
        status: 1,
      };
      await ConsentServices.consentpost(postData);
      message.success("Consent submitted successfully!");
      if (location.state) {
        navigate(location.state);
      } else {
        navigate(APP_ROUTES.HOME);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      message.error("Failed to submit consent.");
    }
  };

  return (
    <Layout>
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${banner})` }}
      />
      <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80 z-50">
        <div className=" relative z-10  min-h-screen flex justify-center items-center p-2">
          <div className="w-full max-w-xs p-3 bg-white shadow-lg rounded-lg">
            <div className="space-y-1 border-2  rounded-md p-2">
              {[
                { key: "terms", label: "Terms & Conditions " },
                { key: "privacy", label: "Privacy Policy" },
                { key: "doctors", label: "Share Medical Records with Doctors" },
                {
                  key: "hospitals",
                  label: "Share Medical Records with Hospitals",
                },
                {
                  key: "pharmacy",
                  label: "Share e-Prescription with Pharmacy",
                },
                {
                  key: "diagnostics",
                  label: "Share e-Prescription with Diagnostics",
                },
              ].map((item) => (
                <div
                  key={item.key}
                  className=" border border-gray-400 rounded-md p-2"
                >
                  <div
                    onClick={() => setActiveModal(item.key)}
                    className="cursor-pointer  font-thin text-sm flex justify-between items-center"
                  >
                    <span>
                      {item.label}{" "}
                      {consentData[item.key] === "Y" ? (
                        <span className="inline-block">
                          {" "}
                          <FaCheck className="text-green-600" />{" "}
                        </span>
                      ) : consentData[item.key] === "N" ? (
                        <span className="inline-block ">
                          {" "}
                          <RxCross1 className="text-red-600 flex justify-center  items-center" />
                        </span>
                      ) : (
                        ""
                      )}
                    </span>
                  </div>
                </div>
              ))}
            </div>
            {activeModal && (
              <Modal
                title={activeModal.replace(/([A-Z])/g, " $1").trim()} // Format title properly
                open={!!activeModal}
                onCancel={() => setActiveModal(null)}
                footer={null}
              >
                <p>
                  {
                    [
                      {
                        key: "terms",
                        description:
                          "By using our services, you agree to comply with our terms and conditions.",
                      },
                      {
                        key: "privacy",
                        description:
                          "Your data is securely stored and only shared with authorized entities.",
                      },
                      {
                        key: "doctors",
                        description:
                          "Allow doctors to access your medical records for better diagnosis.",
                      },
                      {
                        key: "hospitals",
                        description:
                          "Allow hospitals to access your medical history for better treatment.",
                      },
                      {
                        key: "pharmacy",
                        description:
                          "Your prescriptions can be accessed by pharmacies for quick refills.",
                      },
                      {
                        key: "diagnostics",
                        description:
                          "Laboratories can use your e-prescriptions for accurate diagnostics.",
                      },
                    ].find((item) => item.key === activeModal)?.description
                  }
                </p>

                <div className="flex mt-2 justify-end items-center space-x-2">
                  <Checkbox
                    checked={consentData[activeModal] === "N"}
                    onChange={() => handleChange(activeModal, "N")}
                  >
                    Disagree
                  </Checkbox>
                  <Checkbox
                    checked={consentData[activeModal] === "Y"}
                    onChange={() => handleChange(activeModal, "Y")}
                  >
                    I Agree
                  </Checkbox>
                </div>
              </Modal>
            )}

            <div className="flex justify-end mt-5 space-x-4">
              <Button
                className="bg-gray-500"
                // onClick={() => navigate("/")}
                onClick={() => navigate(APP_ROUTES.DASHBOARDNEW)}
                type="primary"
              >
                Skip
              </Button>
              <Button onClick={handleSubmit} type="primary">
                Submit
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default LogConsent;
